import { Address } from '@anyx/shared-utils';

export const CompanyDisplay = ({ address }: { address: Address; hasPrevious: boolean }) => {
  return address?.company ? <span>{address?.company}</span> : null;
};
